"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalError = void 0;
const CustomError_1 = require("./CustomError");
class InternalError extends CustomError_1.CustomError {
    constructor(error, statusCode = 500) {
        super('Internal Server Error');
        this.error = error;
        this.success = false;
        this.getErrors = () => [
            {
                message: this.error,
                field: 'N/A',
            },
        ];
        this.serializeErrors = () => this.getErrors()
            .map((err) => `[<${err.field}> ${err.message}]`)
            .toString();
        this.error = error;
        this.statusCode = statusCode;
        Object.setPrototypeOf(this, InternalError.prototype);
    }
}
exports.InternalError = InternalError;
//# sourceMappingURL=InternalError.js.map